import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearAddRecordLoading,
    clearUpdateRecordError,
    clearUpdateRecordLoading,
    updateRecordFail,
    updateRecordStart,
    updateRecord,
    updateRecordSuccess,
    addRecordToBottom,
    cancelAddRecord,
    cancelUpdateRecord,
    removeRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord,
    fetchListStart,
    fetchListSuccess,
    fetchListFail,
    clearList,
    clearAllLists,
    addToBottomOfLists,
    updateInLists,
    removeFromLists,
} from "../utility";

const initialState = {
    lists: {},
    record: null,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_REQUEST_FOR_BID_LIST_START: return fetchListStart(state, action.payload);
        case actionTypes.FETCH_REQUEST_FOR_BID_LIST_SUCCESS: return fetchListSuccess(state, action.payload);
        case actionTypes.FETCH_REQUEST_FOR_BID_LIST_FAIL: return fetchListFail(state, action.payload);
        case actionTypes.CLEAR_REQUEST_FOR_BID_LIST: return clearList(state, action.payload);
        case actionTypes.CLEAR_REQUEST_FOR_BID_LISTS: return clearAllLists(state);
        case actionTypes.ADD_TO_REQUEST_FOR_BID_LIST: return addToBottomOfLists(state, action.payload);
        case actionTypes.UPDATE_IN_REQUEST_FOR_BID_LIST: return updateInLists(state, action.payload);
        case actionTypes.REMOVE_FROM_REQUEST_FOR_BID_LIST: return removeFromLists(state, action.payload);
        case actionTypes.FETCH_REQUEST_FOR_BID_START: return fetchRecordStart(state);
        case actionTypes.FETCH_REQUEST_FOR_BID_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_REQUEST_FOR_BID_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_REQUEST_FOR_BID: return clearRecord(state);
        case actionTypes.ADD_REQUEST_FOR_BID: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_REQUEST_FOR_BID_START: return addRecordStart(state);
        case actionTypes.ADD_REQUEST_FOR_BID_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_REQUEST_FOR_BID_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_REQUEST_FOR_BID_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_REQUEST_FOR_BID_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_REQUEST_FOR_BID_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_REQUEST_FOR_BID: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_REQUEST_FOR_BID: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_REQUEST_FOR_BID_START: return updateRecordStart(state);
        case actionTypes.UPDATE_REQUEST_FOR_BID_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_REQUEST_FOR_BID_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_REQUEST_FOR_BID_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_REQUEST_FOR_BID_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_REQUEST_FOR_BID_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_REQUEST_FOR_BID: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;